<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_role") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div class="px-6 py-4">
      <form action="">
        <div class="grid gap-x-6 mb-6 md:grid-cols-2">
          <BaseInput
            v-model="ro_name"
            :label="$t('role_name')"
            :placeholder="$t('role_name')"
            :rules="rules"
            :isError="checkRulesIsError(ro_name, 'add').isError"
            :errorMsg="checkRulesIsError(ro_name, 'add').errorMsg"
          />
        </div>
        <div>
          <label for="print">{{ $t("print") }}</label>

          <input class="mx-20" type="checkbox" name="" id="" v-model="print" />
        </div>
        <br />
        <div>
          <label>{{ $t("tutorial") }}</label>

          <input
            class="mx-20"
            type="checkbox"
            name=""
            id=""
            v-model="tutorial"
          />
        </div>
        <br />
        <div>
          <label>{{ $t("allow_employee_profit_view") }}</label>

          <input
            class="mx-20"
            type="checkbox"
            name=""
            id=""
            v-model="profit_visibility"
          />
        </div>
        <br />

        <div class="flex justify-end">
          <label class="-translate-y-1">{{ $t("all") }}</label>

          <input
            class="mx-5"
            type="checkbox"
            name=""
            id=""
            @change="selectDeselectAll"
          />
        </div>
        <br />
        <!--in ltr change (text-right to text-left)-->
        <div class="overflow-x-auto">
          <table
            class="w-full text-right text-gray-500 dark:text-gray-400 modern-table"
          >
            <thead
              class="text-base bg-gray-50 text-gray-700 border-b dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700"
            >
              <tr>
                <th scope="col" class="w-1/6 sm:w-1/4 px-1 sm:px-6 py-3">
                  {{ $t("pages") }}
                </th>
                <th
                  scope="col"
                  class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center"
                >
                  {{ $t("view")
                  }}<input
                    type="checkbox"
                    class="mx-2"
                    name=""
                    id=""
                    @change="selectAllView"
                  />
                </th>
                <th
                  scope="col"
                  class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center"
                >
                  {{ $t("add") }}
                  <input
                    type="checkbox"
                    class="mx-2"
                    name=""
                    id=""
                    @change="selectAllAdd"
                  />
                </th>
                <th
                  scope="col"
                  class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center"
                >
                  {{ $t("edite") }}
                  <input
                    type="checkbox"
                    class="mx-2"
                    name=""
                    id=""
                    @change="selectAllEdit"
                  />
                </th>
                <th
                  scope="col"
                  class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center"
                >
                  {{ $t("delete") }}
                  <input
                    type="checkbox"
                    class="mx-2"
                    name=""
                    id=""
                    @change="selectAllDelete"
                  />
                </th>
                <th
                  scope="col"
                  class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center"
                >
                  {{ $t("detail") }}
                  <input
                    type="checkbox"
                    class="mx-2"
                    name=""
                    id=""
                    @change="selectAllDetail"
                  />
                </th>
              </tr>
            </thead>
            <tbody class="text-base">
              <tr
                class="bg-white text-gray-900 border-b dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                v-for="role in roles"
                :key="role.id"
              >
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-6 py-3">
                  {{ $t(role.name) }}
                </td>
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    v-model="role.view"
                    v-if="role.actions.view"
                  />
                </td>
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    v-model="role.add"
                    v-if="role.actions.add"
                  />
                </td>
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    v-model="role.edit"
                    v-if="role.actions.edit"
                  />
                </td>
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    v-model="role.delete"
                    v-if="role.actions.delete"
                  />
                </td>
                <td class="w-1/6 sm:w-1/4 px-1 sm:px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    v-model="role.detail"
                    v-if="role.actions.detail"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />
        <ButtonInput
          type="button"
          @click="addItem"
          :label="$t('add')"
          :isLoading="isBtnLoading"
        />
      </form>
    </div>
  </div>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
  },
  //data
  data() {
    return {
      isSubmited: false,
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      ro_name: "",
      roles: [
        {
          id: 1,
          name: "dashboard",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        {
          id: 2,
          name: "item_units",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //item_categorys
        {
          id: 3,
          name: "item_categorys",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //waste_items_categorys
        {
          id: 4,
          name: "waste_items_categorys",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //sale_types
        {
          id: 5,
          name: "sale_types",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //sale_platforms
        {
          id: 6,
          name: "sale_platforms",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //sale_citys
        {
          id: 7,
          name: "sale_citys",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //add_new_item
        {
          id: 8,
          name: "items",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //add_item_from_csv
        {
          id: 9,
          name: "add_item_from_csv",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },

        {
          id: 11,
          name: "shortage_items",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        //expire_items
        {
          id: 12,
          name: "expire_items",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        //waste_items
        {
          id: 13,
          name: "waste_items",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        {
          id: 45,
          name: "not_moved_items",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        //boxes
        {
          id: 14,
          name: "boxes",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //exchange_inside_boxes
        {
          id: 15,
          name: "exchange_inside_boxes",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //transfer_between_boxes
        {
          id: 16,
          name: "transfer_between_boxes",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //purchases
        {
          id: 17,
          name: "purchases",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //return_item_to_suplier
        {
          id: 18,
          name: "return_item_to_suplier",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //sales
        {
          id: 19,
          name: "sales",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //return_invoices
        {
          id: 20,
          name: "return_invoices",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //debts
        {
          id: 21,
          name: "debts",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //expense_categorys
        {
          id: 22,
          name: "expense_categorys",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //expenses
        {
          id: 23,
          name: "expenses",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //income_categorys
        {
          id: 24,
          name: "income_categorys",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //incomes
        {
          id: 25,
          name: "incomes",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //reports
        {
          id: 26,
          name: "reports",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        //roles
        {
          id: 27,
          name: "roles",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //employees
        {
          id: 28,
          name: "employees",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //customers
        {
          id: 29,
          name: "customers",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //supliers
        {
          id: 30,
          name: "supliers",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: true,
          },
        },
        //dolar_price
        {
          id: 31,
          name: "dolar_price",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: false,
            delete: true,
            detail: false,
          },
        },
        //notes
        {
          id: 32,
          name: "notes",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            detail: false,
          },
        },
        //barcode
        {
          id: 33,
          name: "barcode",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: false,
            add: true,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        //change_password
        {
          id: 34,
          name: "change_password",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: false,
            add: false,
            edit: true,
            delete: false,
            detail: false,
          },
        },
        //settings
        {
          id: 35,
          name: "settings",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: false,
            add: false,
            edit: true,
            delete: false,
            detail: false,
          },
        },
        //faq
        {
          id: 36,
          name: "faq",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        {
          id: 37,
          name: "activity_history",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        {
          id: 38,
          name: "backup",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: false,
            add: true,
            edit: false,
            delete: false,
            detail: false,
          },
        },
        {
          id: 39,
          name: "slider",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
          },
        },
        //40 smart search
        {
          id: 40,
          name: "smart_search",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: false,
            edit: false,
            delete: false,
          },
        },
        {
          id: 46,
          name: "sarmaya",
          view: false,
          add: false,
          edit: false,
          delete: false,
          detail: false,
          actions: {
            view: true,
            add: true,
            edit: true,
            delete: true,
          },
        },
      ],
      print: false,
      tutorial: false,
      profit_visibility: true,
    };
  },
  //computed
  computed: {
    isBtnLoading() {
      return this.$store.state.add_role.isBtnLoading;
    },
  },
  //methods
  methods: {
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    //selectDeselectAll
    selectDeselectAll(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          this.roles[index].view = e.target.checked;
          this.roles[index].add = e.target.checked;
          this.roles[index].edit = e.target.checked;
          this.roles[index].delete = e.target.checked;
          this.roles[index].detail = e.target.checked;
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllAdd(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          if (this.roles[index].actions.add) {
            this.roles[index].add = e.target.checked;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllView(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          if (this.roles[index].actions.view) {
            this.roles[index].view = e.target.checked;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllEdit(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          if (this.roles[index].actions.edit) {
            this.roles[index].edit = e.target.checked;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllDelete(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          if (this.roles[index].actions.delete) {
            this.roles[index].delete = e.target.checked;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectAllDetail(e) {
      try {
        for (let index = 0; index < this.roles.length; index++) {
          if (this.roles[index].actions.detail) {
            this.roles[index].detail = e.target.checked;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addItem() {
      //check form validation
      if (this.$store.state.add_role.isBtnLoading) return;

      this.isSubmited = true;
      if (this.checkRulesIsError(this.ro_name, "add").isError) {
        return;
      }
      this.$store.state.add_role.isBtnLoading = true;
      var res = await this.$store.dispatch("add_role/addNewItem", {
        ro_name: this.ro_name,
        ro_access: {
          print: this.print,
          tutorial: this.tutorial,
          profit_visibility: this.profit_visibility,
          roles: this.roles,
        },
      });
      if (res.status == 200) {
        this.ro_name = "";
        this.isSubmited = false;
      }
    },
  },
};
</script>
